import { render, staticRenderFns } from "./CardAvatar.vue?vue&type=template&id=f121ab0c"
import script from "./CardAvatar.vue?vue&type=script&lang=js"
export * from "./CardAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports